const workflowTypes = {
  FETCH_WORKFLOWS_REQUEST: 'SAF_APPLY_FETCH_WORKFLOWS_REQUEST',
  FETCH_WORKFLOWS_SUCCESS: 'SAF_APPLY_FETCH_WORKFLOWS_SUCCESS',
  FETCH_WORKFLOWS_FAILURE: 'SAF_APPLY_FETCH_WORKFLOWS_FAILURE',

  CREATE_WORKFLOWS_REQUEST: 'SAF_APPLY_CREATE_WORKFLOWS_REQUEST',
  CREATE_WORKFLOWS_SUCCESS: 'SAF_APPLY_CREATE_WORKFLOWS_SUCCESS',
  CREATE_WORKFLOWS_FAILURE: 'SAF_APPLY_CREATE_WORKFLOWS_FAILURE',

  EDIT_WORKFLOWS_REQUEST: 'SAF_APPLY_EDIT_WORKFLOWS_REQUEST',
  EDIT_WORKFLOWS_SUCCESS: 'SAF_APPLY_EDIT_WORKFLOWS_SUCCESS',
  EDIT_WORKFLOWS_FAILURE: 'SAF_APPLY_EDIT_WORKFLOWS_FAILURE',

  DELETE_WORKFLOWS_REQUEST: 'SAF_APPLY_DELETE_WORKFLOWS_REQUEST',
  DELETE_WORKFLOWS_SUCCESS: 'SAF_APPLY_DELETE_WORKFLOWS_SUCCESS',
  DELETE_WORKFLOWS_FAILURE: 'SAF_APPLY_DELETE_WORKFLOWS_FAILURE',

};

export default workflowTypes;
